import { T } from "../lib/theme";

const Card = ({ children, style: extra = {}, className = "" }) => (
  <div
    className={className}
    style={{
      background:    T.bg1,
      border:        `1px solid ${T.border1}`,
      borderRadius:  14,
      padding:       22,
      boxShadow:     T.shadow,
      transition:    "border-color 0.18s, box-shadow 0.18s",
      ...extra,
    }}
  >
    {children}
  </div>
);

export default Card;
